import swipers from "@/modules/swipers.js";
import Alpine from "alpinejs";


// const roomsFilterWrapper = document.getElementById('room-inner-filter');

const shortTermRoomsTab = document.getElementById('short-term-room-tab');
const longTermRoomsTab = document.getElementById('long-term-room-tab');

const shortFilterRooms = document.querySelector('.js-short-filter');
const longFilterRooms = document.querySelector('.js-long-filter');

const filterSeasonsWrapper = document.getElementById('filterSeasonsWrapper');
const filterSeasonCheckboxes = document.querySelectorAll('#filterSeasonsWrapper .filter-checkbox');

//ROOMS FILTER POP UP ITEMS:
const roomsSelectPopup = document.getElementById('roomsSelectPopup');
const closeSelectPopupButton = document.getElementById('closeSelectPopup');
const roomsSelectPopupTriggers = document.querySelectorAll('.js-select-popup-trigger');
const longTermCheckbox = document.getElementById('long-term-rent');
const popupSeasonsList = document.getElementById('popupSeasonsList');

const roomsPage = document.querySelector('body.page-template-template-rooms');


let roomCards;
const roomsSizeFilters = document.querySelectorAll('#roomSizeFilterWrapper input[type=radio]');


if (roomsSizeFilters.length > 0){
    roomsSizeFilters.forEach(filter=>{
        filter.addEventListener('change', ()=>{
            roomCards = document.querySelectorAll('#long-term-room-tab .room-item');


            const currentFilter = filter.value;

            if (filter.checked) {
                // Uncheck all other filters first
                roomsSizeFilters.forEach(otherFilter => {
                    if (otherFilter !== filter) {
                        otherFilter.checked = false;
                    }
                });

                // Apply filter (handles both 'all' and specific filters)
                if (currentFilter === 'all') {
                    showAllRooms();
                } else {
                    filterRoomsSize(currentFilter);
                }
            } else {
                // Any filter unchecked = show all
                showAllRooms();
            }
        })
    })
}

function filterRoomsSize(attribute){
    roomCards.forEach(room=>{

        const roomAttribute = room.dataset.roomFilter;

        if (roomAttribute === attribute) {
            room.classList.remove('hidden')
        }else{
            room.classList.add('hidden')
        }

    })
}

function showAllRooms() {
    roomCards.forEach(room => {
        room.classList.remove('hidden');
    });
}



let lastSelectedSeason = '';
let isLoading = false;


if (roomsPage){

    document.addEventListener('DOMContentLoaded', () => {
        /*
        Custom event dispatched for gtm-tracking.js file to get info.
         */
        window.dispatchEvent(new CustomEvent('roomsFilteredBySeason'));
    })


    const urlParams = new URLSearchParams(window.location.search)
    const hasSeasonParam = urlParams.has('season');
    const hash = window.location.hash;


    if (hasSeasonParam){
        lastSelectedSeason = urlParams.get('season');
    }else{
        console.log(filterSeasonCheckboxes)
        // if season is empty preselect first season
        // And preselect first season for long term
        if (filterSeasonCheckboxes.length > 0) {
            const firstSeasons = filterSeasonCheckboxes[0];
            filterSeasonCheckboxes[0].checked = true;
            lastSelectedSeason = firstSeasons.value;

            //preload long term rooms
            const data = new FormData();
            data.append('action', 'load_rooms');
            data.append('season', lastSelectedSeason);
            data.append('nonce', ajaxObject.nonce);
            isLoading = true;

            fetchLongTermRooms(data)
        }
    }

    if (!hasSeasonParam && hash !== '#short'){
        showRoomsSelectPopup()
    }
}

//Show seasons only if long term is selected
if (longTermCheckbox){
    longTermCheckbox.addEventListener('change', ()=>{
        if (longTermCheckbox.checked){
            popupSeasonsList.classList.remove('hidden')
        }else{
            popupSeasonsList.classList.add('hidden')
        }
    })
}


roomsSelectPopupTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e)=>{
        e.preventDefault()

        if (trigger.classList.contains('js-long-term')){
            // longTermCheckbox.checked = true;
            // longTermCheckbox.dispatchEvent(new Event('change'))
        }
        showRoomsSelectPopup()
    })
})

closeSelectPopupButton.addEventListener('click', ()=> {
    roomsSelectPopup.classList.add('hidden');
})

function showRoomsSelectPopup(){
    roomsSelectPopup.classList.remove('hidden');
}

window.addEventListener('invalidSeason', () => {
    // console.log('event received')
    showRoomsSelectPopup();
});

if (longFilterRooms) {
    longFilterRooms.addEventListener('click', () => {

        window.location.hash = 'long';

        if (lastSelectedSeason !== ''){
            const url = new URL(window.location.href);
            url.searchParams.set('season', lastSelectedSeason);
            history.replaceState({}, '', url.toString());
        }

        shortFilterRooms.classList.remove('active');
        longFilterRooms.classList.add('active');

        filterSeasonsWrapper.classList.remove('hidden');

        shortTermRoomsTab.classList.add('hidden');
        longTermRoomsTab.classList.remove('hidden');

  });
}


if (shortFilterRooms) {
    shortFilterRooms.addEventListener('click', () => {

        const cleanUrl = window.location.origin + window.location.pathname + '#short';
        window.history.replaceState({}, document.title, cleanUrl);

        shortFilterRooms.classList.add('active');
        longFilterRooms.classList.remove('active');

        shortTermRoomsTab.classList.remove('hidden');
        longTermRoomsTab.classList.add('hidden');

        filterSeasonsWrapper.classList.add('hidden');

        // filterCheckboxes.forEach(checkbox=>{
        //     checkbox.checked = false;
        // })

    });
}

const roomsFilterWrapper = document.getElementById('roomsFilterWrapper');
const filterCheckboxes = document.querySelectorAll('.filter-checkbox');

const roomsLoader = document.getElementById('rooms-loader');
const roomsContainer = document.getElementById('rooms-container');

const roomSizeFilterAll = document.getElementById('filter-all');



if (roomsFilterWrapper){

    roomsFilterWrapper.addEventListener('click', (e)=>{
        if (isLoading) {
            e.preventDefault();
            return;
        }
    }, true)


    roomsFilterWrapper.addEventListener('change', (e) => {

        if (isLoading) {
            e.preventDefault();
            return;
        }

        // Check if the changed element is actually a radio button
        e.preventDefault();
        if (e.target.type === 'checkbox') {

            const seasonId = e.target.value;

            if (!e.target.checked) {
                e.target.checked = true;
                console.log('same checkbox')
                return;
            }

            // shortTermRoomsTab.classList.add('hidden');
            // longTermRoomsTab.classList.remove('hidden');

            filterCheckboxes.forEach(checkbox=>{

                if (checkbox.value !== seasonId){
                    checkbox.checked = false;
                }
            })

            roomsContainer.style.display = 'none';
            roomsLoader.style.display = 'flex';

            const data = new FormData();
            data.append('action', 'load_rooms');
            data.append('season', seasonId);
            data.append('nonce', ajaxObject.nonce);
            isLoading = true;

            if (roomSizeFilterAll){
                roomSizeFilterAll.checked = true;
            }
            fetchLongTermRooms(data);

            // Update URL
            const url = new URL(window.location.href);
            url.searchParams.set('season', seasonId);
            history.replaceState({}, '', url.toString());

        }
    });
}


function fetchLongTermRooms(data){
    fetch(ajaxObject.ajax_url, {
        method: "POST",
        // credentials: 'same-origin',
        body: data
    })
        .then(response => {
            if (!response.ok) {
                throw new Error(`[${response.status}] ${response.statusText}`);
            }
            return response.json();
        })
        .then(response => {
            console.log(response);
            roomsContainer.innerHTML = response.data.html;
            roomsContainer.style.display = 'grid';
            roomsLoader.style.display = 'none';
            isLoading = false;
            swipers();

            /*
            Custom event dispatched for gtm-tracking.js file to get info.
             */
            window.dispatchEvent(new CustomEvent('roomsFilteredBySeason'));




        })
        .catch(error => {
            console.error(error);
        });
}
// document.addEventListener('alpine:initialized', () => {
//     // Now try your function
//     function yourFunction() {
//         console.log('Store value:', Alpine.store('appState'));
//     }
//
//     // Test the function
//     yourFunction();
// });

// document.addEventListener('alpine:initialized', () => {
//     // Small timeout to ensure the component is mounted
//     setTimeout(() => {
//         const element = document.querySelector('[x-data="app"]');
//         if (element) {
//             const appData = Alpine.$data(element);
//             console.log(appData.menuOpen); // Should now show your data
//
//             // menuOpen: false,
//             // openlightbox: false,
//             // buttonSwitcher: false,
//
//
//         }
//     }, 0);
// });